import { _PROXIMIDAD_CTRL } from "../../ui/controllers/ProximidadController";
import { apiUsuarioObtenerGrupos } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, IGroup } from "../models/Entities";
import { RequestData } from "../utils/RequestData";
import { _GRUPOSINFO_MAP } from "./Grupo";


/**
 * Obtiene los grupos del usuario y los agrega al diccionario {@link _GRUPOSINFO_MAP} y al controlador de proximidad {@link _PROXIMIDAD_CTRL}
 */
export function _SvUsuarioObtenerGrupos(callback: (groups: IGroup[]) => void) {
    let params = {
        IdUsuario: _APP_DATA.userData.IdUsuario
    };

    new RequestData<IApiResult<IGroup[]>>(apiUsuarioObtenerGrupos)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response?.Datos || [];

            if (error || !response?.Datos) {
                console.log(error, response);
                if (callback) callback(null);
                return;
            }

            resultData.forEach(group => {
                _GRUPOSINFO_MAP.set(group.IdGrupo, group);
            });
            _PROXIMIDAD_CTRL._SetGroups(resultData);

            if (callback) callback(resultData);
        }).Get();
}
